export enum EListingTileTagSlug {
  Superhost = 'superhost',
  BeginnerFriendly = 'beginner-friendly',
  GuestFavorite = 'guest-favorite',
}
